import React from "react";

export default function renderIcon({
  width = 22,
  height = 22,
  color = "#4B247E",
}) {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width={width}
    //   height={height}
    //   viewBox="0 0 21 17"
    // >
    //   <path
    //     id="Polygon_210"
    //     data-name="Polygon 210"
    //     d="M10.5,0,21,17H0Z"
    //     transform="translate(21 17) rotate(180)"
    //     fill={color}
    //   />
    // </svg>
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.74922 4.58311H19.2492C19.4163 4.58364 19.58 4.62971 19.7228 4.71638C19.8657 4.80304 19.9821 4.92702 20.0597 5.07495C20.1373 5.22289 20.1731 5.3892 20.1632 5.55596C20.1534 5.72272 20.0982 5.88363 20.0036 6.02137L11.7536 17.938C11.4117 18.4321 10.5886 18.4321 10.2457 17.938L1.99572 6.02137C1.90023 5.88392 1.84423 5.72293 1.83381 5.55589C1.82339 5.38885 1.85894 5.22214 1.93661 5.07389C2.01428 4.92564 2.13109 4.80151 2.27436 4.71498C2.41762 4.62846 2.58186 4.58285 2.74922 4.58311Z"
        fill={color}
      />
    </svg>
  );
}
